import React from "react";
import { withRouter } from "react-router-dom";
import { loadScript } from "@paypal/paypal-js";
import { makeRequestAuth } from "../../utils/globals";
import Header from "../../components/Header";
import { IconPayment } from "../../components/Icons";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import ImageLoader from "../../components/ImageLoader";
var downloadTimer;
class PaypalPayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      finaTotal: "",
      company_recharge: "",
      sales_order_id: "",
      paypal_order_id: "",
      callbackUrl: "",
      origin: "",
      currency: "",
      onapproveLoading: false,
      product_type: "",
      formatedtotal: "",
      currencySymbol: "",
      telephone: "",
      finalStep: false,
      modalState: false,
      successModal: false,
      isd_code: "",
      addFund: "",
      showHeading: true,
      phoneSuccess: "",
      payPalButtonloader: false,
      client_Id: "",
      formatedNetAmount: "",
      discountPercent: "",
      formatDiscountAmount: "",
      gst: "",
      gstAmount: "",
      gstPercent: "",
      formatedMarkupAmount: "",
      paymentGatewayFeePercent: "",
      formatedPaymentGatewayAmount: "",
      markupPercent: "",
    };
  }

  async componentDidMount() {
    const response = this.props.history.location.state
      ? JSON.parse(this.props.history.location.state)
      : "";
    this.setState({
      finaTotal: response.finaTotal ? response.finaTotal : "",
      company_recharge: response.company_recharge,
      callbackUrl: response.udfUrl ? response.udfUrl : "",
      origin: response.company_recharge == "2" ? "plumPro" : "plum",
      product_type: response.product_type ? response.product_type : "",
      formatedtotal: response.formatedtotal ? response.formatedtotal : "",
      currencySymbol: response.currencySymbol ? response.currencySymbol : "",
      telephone: response.telephone ? response.telephone : "",
      isd_code: response.isd_code ? response.isd_code : "",
      addFund: response.addFund ? response.addFund : "",
      phoneSuccess: response.addFund ? response.addFund : "",
      formatedNetAmount: response.formatedNetAmount
        ? response.formatedNetAmount
        : "",
      discountPercent: response.discountPercent ? response.discountPercent : "",
      formatDiscountAmount: response.formatDiscountAmount
        ? response.formatDiscountAmount
        : "",
      markupPercent: response.markupPercent ? response.markupPercent : "0",
      gst: response.gst ? response.gst : "",
      gstAmount: response.gstAmount ? response.gstAmount : "",
      gstPercent: response.gstPercent ? response.gstPercent : "0",
      formatedMarkupAmount: response.formatedMarkupAmount
        ? response.formatedMarkupAmount
        : "",
      paymentGatewayFeePercent: response.paymentGatewayFeePercent
        ? response.paymentGatewayFeePercent
        : "",
      formatedPaymentGatewayAmount: response.formatedPaymentGatewayAmount
        ? response.formatedPaymentGatewayAmount
        : "",
    });

    this.setState({ payPalButtonloader: true });
    let clientApiResponse = await this.getClientID(
      response.currencySymbol ? response.currencySymbol : ""
    );
    if (clientApiResponse.getClientId.error == false) {
      let client_id = clientApiResponse.getClientId.client_id
        ? clientApiResponse.getClientId.client_id
        : "";
      this.setState({ payPalButtonloader: false, client_Id: client_id });
      let currencySymbol = response.currencySymbol
        ? response.currencySymbol
        : "";
      loadScript({ "client-id": client_id, currency: currencySymbol })
        .then((paypal) => {
          const this1 = this;
          paypal
            .Buttons({
              createOrder: function (data, actions) {
                return this1.createOrder(data, actions);
              },
              onApprove: function (data, actions) {
                return this1.onApprove(data, actions);
              },
            })
            .render("#paypal-button-container");
        })
        .catch((err) => {
          console.error("failed to load the PayPal JS SDK script", err);
        });
    } else {
      NotificationManager.error(
        clientApiResponse.getClientId.message
          ? clientApiResponse.getClientId.message
          : "Something went wrong, Please try again. ",
        "Failure"
      );
      this.setState({ payPalButtonloader: false, client_Id: "" });
      var timeleft = 1;
      downloadTimer = setInterval(
        function () {
          timeleft--;
          this.setState({ timer: timeleft });
          if (timeleft <= 0) {
            clearInterval(downloadTimer);
            this.moveToRecharge();
          }
        }.bind(this),
        2000
      );
    }
  }
  moveToRecharge = () => {
    this.props.history.push("/admin/recharge");
  };

  getClientID = (currencycode) => {
    return new Promise((resolve, reject) => {
      const paymentMethodType = {
        query: "paypal.query.get_client_id",
        tag: "paypal",
        variables: {
          curreny: currencycode,
        },
      };
      makeRequestAuth(paymentMethodType, function (response) {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve(0);
        }
      });
    });
  };

  createOrder() {
    return this.onCreateOrderApiCall("ghjkjhvcvn").then((response) => {
      this.setState({ loader: false });
      if (response) {
        if (response.data.createOrder.error == false) {
          this,
            this.setState({
              paypal_order_id: response.data.createOrder.paypal_order_id
                ? response.data.createOrder.paypal_order_id
                : "",
              sales_order_id: response.data.createOrder.sales_order_id
                ? response.data.createOrder.sales_order_id
                : "",
              currency: response.data.createOrder.currency
                ? response.data.createOrder.currency
                : "",
            });
          return response.data.createOrder.paypal_order_id
            ? response.data.createOrder.paypal_order_id
            : "";
        } else {
          let errorMeessage = response.data.createOrder.message
            ? response.data.createOrder.message[0]
            : "Something went wrong, Please try again. ";
          NotificationManager.error(errorMeessage, "Failure");
          return "";
        }
      } else {
        NotificationManager.error(
          "Something went wrong, Please try again. ",
          "Failure"
        );
        return "";
      }
    });
  }

  onApprove(data) {
    let order_Id = btoa(data.orderID);
    this.setState({ onapproveLoading: true });
    return this.onApproveOrderApiCall(data.orderID).then((response) => {
      this.setState({ onapproveLoading: false });
      if (response.approverOrder.error == false) {
        this.props.history.push({
          pathname: "/admin/paypal-recharge-callback/" + order_Id,
          state: JSON.stringify({
            order_id: data.orderID,
            status: "success",
            company_recharge: this.state.company_recharge
              ? this.state.company_recharge
              : "",
            callbackUrl: this.state.callbackUrl,
            origin: this.state.company_recharge == "2" ? "plumPro" : "plum",
            sales_order_id: this.state.sales_order_id,
          }),
        });
      } else if (
        response.approverOrder.error &&
        response.approverOrder.errorCode == 101
      ) {
        loadScript({
          "client-id": this.state.client_Id,
          currency: this.state.currencySymbol,
        })
          .then((paypal) => {
            const this1 = this;
            paypal
              .Buttons({
                createOrder: function (data, actions) {
                  return this1.createOrder(data, actions);
                },
                onApprove: function (data, actions) {
                  return this1.onApprove(data, actions);
                },
              })
              .render("#paypal-button-container");
          })
          .catch((err) => {
            console.error("failed to load the PayPal JS SDK script", err);
          });
        NotificationManager.error(
          "Insufficient balance ,please try other mode of payment",
          "Failure"
        );
      } else {
        this.props.history.push({
          pathname: "/admin/paypal-payment-status/fail/" + order_Id,
          state: JSON.stringify({
            order_id: data.orderID,
            status: "fail",
            callbackUrl: this.state.callbackUrl,
            origin: this.props.company_recharge == "2" ? "plumPro" : "plum",
          }),
        });
      }
    });
  }
  onCancel() {}

  proformaInvoice = () => {
    NotificationManager.error("No Data Available", "Error");
    //this.props.proforma(this.state.showHeading)
    this.state.telephone && this.state.isd_code && !this.state.phoneSuccess
      ? this.setState({
          modalState: !this.state.modalState,
        })
      : null;
  };
  generateInvoice = () => {
    const { accountReducer = {} } = this.props;
    const { addFund, product_type, isd_code, telephone } = this.state;
    let employeeDetails = accountReducer ? accountReducer.employeeDetails : "";
    let email =
      employeeDetails && employeeDetails.employee_email
        ? employeeDetails.employee_email
        : null;
    let data = {
      total: addFund,
      product_type: product_type,
      email: email,
      mobile: isd_code + "-" + telephone,
    };
    ProfileService.proformaInvoice(data).then((response) => {
      if (
        response !== undefined &&
        response.data.getProformaInvoice.status &&
        response.data.getProformaInvoice.statusMessage == "Success"
      ) {
        this.setState({
          order_id: response.data.getProformaInvoice.data.order_id,
          statusMessage: response.data.getProformaInvoice.statusMessage,
        });
      } else {
        this.setState({
          statusMessage: response.data.getProformaInvoice.statusMessage,
        });
      }
    });
    this.setState({
      successModal: !this.state.successModal,
      modalState: false,
    });
  };
  //Api call

  onCreateOrderApiCall() {
    return new Promise((resolve, reject) => {
      let mobile = this.state.isd_code ? this.state.isd_code + "-" : "";
      this.state.telephone ? (mobile += this.state.telephone) : null;
      const query = "paypal.mutation.create_order";
      const request_data = {
        query,
        tag: "paypal",
        variables: {
          add_data: {
            total: parseFloat(this.state.finaTotal).toFixed(2),
            company_recharge: parseInt(this.state.company_recharge),
            mobile: mobile,
            markup: parseFloat(this.state.markupPercent).toFixed(2),
            otp_id: "",
            otp: "",
            payment_gateway_fee: parseFloat(
              this.state.paymentGatewayFeePercent
            ).toFixed(2),
            discount: parseFloat(this.state.discountPercent).toFixed(2),
            gst: parseFloat(this.state.gstPercent).toFixed(2),
          },
        },
      };
      makeRequestAuth(request_data, function (response) {
        if (response.data) {
          resolve(response);
        } else {
          resolve(0);
        }
      });
    });
  }

  onApproveOrderApiCall(orderId) {
    return new Promise((resolve, reject) => {
      const query = "paypal.mutation.approver_order";
      const request_data = {
        query,
        tag: "paypal",
        variables: {
          add_data: {
            paypal_order_id: orderId,
            order_id: this.state.sales_order_id,
            currency: this.state.currency,
          },
        },
      };
      makeRequestAuth(request_data, function (response) {
        if (response.data) {
          resolve(response.data);
        } else {
          resolve(response);
          // NotificationManager.error('Failed to authenticate', 'Failure')
        }
      });
    });
  }

  render() {
    const { accountReducer } = this.props;
    let walletCompany =
      accountReducer &&
      accountReducer.typeData &&
      accountReducer.typeData.walletCompany
        ? accountReducer.typeData.walletCompany
        : "";
    let { modalState, successModal } = this.state;
    let employeeDetails = accountReducer ? accountReducer.employeeDetails : "";
    let email =
      employeeDetails && employeeDetails.employee_email
        ? employeeDetails.employee_email
        : null;
    return (
      <>
        <div className="paymentWrapper ">
          <div className="container-fluid ">
            <Header
              companyDetails={accountReducer && accountReducer.companyDetails}
              accountReducer={accountReducer}
            />
            {!this.state.onapproveLoading ? (
              <div>
                <div className="complete-payment">Complete your payment</div>
                <div className="paypal-payment-details">
                  <div className="complet-payment">
                    <IconPayment />{" "}
                    <span
                      className="paypal-payment-details-sub"
                      style={{ fontSize: "16px" }}
                    >
                      {" "}
                      Payment details
                    </span>
                  </div>
                  <div
                    style={{ width: "auto", border: "1px solid #EEEEEE" }}
                  ></div>
                  <div className="payment-brakup">
                    <div className="account-type">
                      <span className="details_Text">Account Type</span>
                      <span className="sub-account-type">
                        {this.state.company_recharge === 1
                          ? "Emplus Fund"
                          : walletCompany
                          ? "Wallet Fund"
                          : this.state.company_recharge === 2
                          ? "Plum Pro Fund"
                          : "Wallet Fund"}
                      </span>
                    </div>
                    <div className="account-type">
                      <span className="details_Text">Net Amount</span>
                      <span className="sub-account-type">
                        {this.state.formatedNetAmount}
                      </span>
                    </div>
                    <div className="account-type">
                      <span className="details_Text">Other Charges </span>
                    </div>
                    {this.state.markupPercent != "0" ? (
                      <div className="account-type">
                        <span className="discount_Text">
                          {" "}
                          Markup Charges at {this.state.markupPercent}%{" "}
                        </span>
                        <span className="discount_sub-account-type">
                          {this.state.formatedMarkupAmount}{" "}
                        </span>
                      </div>
                    ) : null}
                    {this.state.discountPercent != "0" ? (
                      <div className="account-type">
                        <span className="discount_Text">
                          {" "}
                          Discount at {this.state.discountPercent}%{" "}
                        </span>
                        <span className="discount_sub-account-type">
                          {this.state.formatDiscountAmount}{" "}
                        </span>
                      </div>
                    ) : null}
                    <div className="account-type">
                      <span className="discount_Text">
                        {" "}
                        {this.state.paymentGatewayFeePercent}% processing fee
                      </span>
                      <span className="discount_sub-account-type">
                        {this.state.formatedPaymentGatewayAmount}{" "}
                      </span>
                    </div>
                    <div
                      style={{
                        width: "auto",
                        border: "1px solid #EEEEEE",
                        marginTop: "5px",
                      }}
                    ></div>
                    <div className="account-type">
                      <span className="details_Text">Total Payable</span>
                      <span className="sub-account-type">
                        {this.state.formatedtotal}
                      </span>
                    </div>
                    {/*
                          <div className='account-type'>
                            <div >
                            {!this.state.finalStep ?
                            <CustomTooltip
                            id={'tooltip'} 
                            postion='top'
                            tiptext='Proforma Invoice is a preliminary Invoice that will give you the estimate of the purchase for financial accounting purpose.' 
                            showtext={
                              <span className='paylater' >Do you want to pay later? <a onClick={() => {this.proformaInvoice()}} style={{color : '#0172CB',fontSize : '14px'}} className='default'>Generate Proforma Invoice</a></span>
                              } 
                            />
                              : null}
                            </div>
                        </div> */}

                    <div
                      style={{
                        width: "auto",
                        border: "1px solid #EEEEEE",
                        marginTop: "5px",
                      }}
                    ></div>
                    {!this.state.payPalButtonloader ? (
                      <div
                        className="account-type"
                        style={{ textAlign: "center" }}
                        id="paypal-button-container"
                      ></div>
                    ) : (
                      <ImageLoader />
                    )}

                    <div
                      style={{ width: "auto", border: "1px solid #EEEEEE" }}
                    ></div>
                    {/*<div>
                            <span className="paypal_information_txt">For payment by credit/debit card or wallet, an extra transaction fee of 2% will be charged by the Payment gateway partner.</span>
                        </div>*/}
                    <br />
                    <ul>
                      <li className="paypal_information_txt1">
                        For payment by credit/debit card through a bank that is
                        different from your base currency, your bank may charge
                        up to 4% extra depending on the type of card.
                      </li>
                      <li className="paypal_information_txt1">
                        For avoiding credit/debit card charges please request a
                        direct bank transfer by contacting your account manager.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="col-md-12"
                style={{
                  position: "relative",
                  minHeight: "400px",
                  textAlign: "center",
                  marginTop: "30px",
                }}
              >
                <img
                  src="/admin/img/loading.gif"
                  width="30px"
                  style={{ margin: "0px 0px 0px 20px" }}
                />
                <div style={{ marginTop: "1rem" }}>
                  <h4>
                    Please do not refresh the page and we are fetching the
                    payment details...
                  </h4>
                </div>
              </div>
            )}
            <NotificationContainer />
          </div>
        </div>
        {modalState ? (
          <ProformaInvoice
            headerTitle="Generate Proforma Invoice"
            header="Proforma invoice"
            body="Generate a Proforma invoice and make the payment later on the payment history page of your Admin dashboard."
            subTitle="Please Note :"
            subBody="You can generate gift cards only after completing the payment."
            modalStatus={() => {
              this.proformaInvoice();
            }}
            buttonText="Generate Proforma Invoice"
            btnText2="Cancel"
            actionProformaHandler={() => {
              this.generateInvoice();
            }}
          />
        ) : null}
        {successModal ? (
          <ProformaInvoice
            header="Proforma Invoice Generated Successfully!"
            body={`The Invoice has been shared with ${email}. You can also download it from the payment history page of your Admin dashboard.`}
            subTitle="Please Note :"
            subBody="Your account will be credited only after the payment is done."
            modalStatus={() => {
              this.setState({ successModal: false, modalState: false });
            }}
            buttonText="Ok"
            actionProformaHandler={() => {
              this.handleSubmit();
            }}
          />
        ) : null}
      </>
    );
  }
}
export default withRouter(PaypalPayment);
